import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifiedByComponent } from './verified-by.component';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [VerifiedByComponent],
  exports: [VerifiedByComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
  ]
})
export class VerifiedByModule { }
